module.exports = {
    title: "AI & Auto-AI Interview Plan",
    crud: {
        create: "Create AI & Auto-AI Interview Plan",
        edit: "Edit AI & Auto-AI Interview Plan",
        view: "View AI & Auto-AI Interview Plan",
    },
    table: {
        title:'Title',
        platform:'Platform',
        userType:'User Type',
        skuCodeAndroid:'SKU Code Android',
        skuCodeIos:'SKU Code IOS',
        minutes:'Minutes',
        createdAt:'Created At',
        action: "Action",
    },
    form: {
        type: "Type",
        skuCodeAndroid:'SKU Code Android',
        skuCodeIos:'SKU Code IOS',
        title: "Title",
        description: "Description",
        platform: "Platform",
        price: "Price",
        offerPrice: "Offer Price",
        country: "Country",
        duration: "Duration",
        durationValue: "Duration Value",
        minutes:'Minutes',
    },
    validation: {
        required: {
            title: 'Title is required',
            type: 'Type is required',
            skuCodeAndroid:'Android SKU ID is required',
            skuCodeIos:'IOS SKU ID is required',
            description: 'Description is required',
            platform: 'Platform is required',
            minutes: 'Minutes is required',
            minutes: 'Minutes is required',
            duration: 'Duration is required',
            durationValue: 'Duration value is required',
        }
    },
}
